var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeVerticalDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 3.33336C10.9207 3.33336 11.6669 2.58716 11.6669 1.66668C11.6669 0.746198 10.9207 0 10.0002 0C9.0797 0 8.3335 0.746198 8.3335 1.66668C8.3335 2.58716 9.0797 3.33336 10.0002 3.33336Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 11.6664C10.9207 11.6664 11.6669 10.9202 11.6669 9.99969C11.6669 9.07921 10.9207 8.33301 10.0002 8.33301C9.0797 8.33301 8.3335 9.07921 8.3335 9.99969C8.3335 10.9202 9.0797 11.6664 10.0002 11.6664Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 20.0004C10.9207 20.0004 11.6669 19.2542 11.6669 18.3337C11.6669 17.4132 10.9207 16.667 10.0002 16.667C9.0797 16.667 8.3335 17.4132 8.3335 18.3337C8.3335 19.2542 9.0797 20.0004 10.0002 20.0004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeVerticalDots);
export default __webpack_public_path__ + "static/media/threeVerticalDots.77f3d2f2ea73864ee9e65333efb8dc9c.svg";
export { ForwardRef as ReactComponent };